<template>
  <div>
    <div id="services">
      <h1 class="page-title">
        nossos
        <span class="highlight">serviços</span>
      </h1>
      <ServiceList :servicesArray="services" />
    </div>
  </div>
</template>

<script>
import ServiceList from "@/components/ServiceList";

export default {
  components: {
    ServiceList
  },
  data() {
    return {};
  },
  created() {
    this.$store.dispatch("FETCH_SERVICES");
  },
  computed: {
    services() {
      return this.$store.state.services;
    }
  }
};
</script>

<style scoped lang="scss">
#services {
  display: flex;
  flex-direction: column;
  width: 100%;
}
</style>
